import React, { useState } from 'react';
import { navData } from '@/utils/navData';
import Link from 'next/link';

const DesktopHeader = () => {
  const [showStory, setShowStory] = useState(false);
  const [showStandards, setShowStandards] = useState(false);
  const [showHomes, setShowHomes] = useState(false);
  const [showPartners, setShowPartners] = useState(false);
  const [showAboutUs, setShowAboutUs] = useState(false);

  const resetView = () => {
    setShowStory(false);
    setShowStandards(false);
    setShowHomes(false);
    setShowPartners(false);
    setShowAboutUs(false);
  };

  return (
    <div className="float-right hidden smDesktop:block">
      <nav role="navigation" aria-label="Main menu" className="mt-[5px]">
        <ul className="flex list-none flex-wrap justify-end">
          <li className="group list-none hover:bg-black-standard/15">
            <div
              className="relative m-0 box-border cursor-pointer list-none px-4 py-[0.7rem] font-source-sans text-[1.25rem] font-normal tracking-[-0.3px] text-white no-underline transition-opacity duration-300 hover:bg-black-standard/15 group-hover:block"
              onClick={(e) => {
                e.preventDefault();
                setShowStory(true);
              }}
              onMouseEnter={(e) => {
                e.preventDefault();
                setShowStory(true);
              }}
            >
              <Link
                href={navData.ourStory.slug}
                target="_self"
                className="relative block list-none px-0 py-3 font-source-sans text-[1.25rem] font-normal leading-[1.5rem] tracking-[-0.3px] text-white no-underline transition-opacity duration-300"
              >
                {navData.ourStory.title}
              </Link>
            </div>
            {showStory && (
              <ul className="absolute top-full z-[201] hidden border border-solid border-black-standard/10 bg-white shadow-component group-hover:block">
                {navData.ourStory.items.map(
                  (item, index) =>
                    item.isHeader && (
                      <li
                        key={index}
                        className="p-3 hover:bg-black-standard/15"
                      >
                        <Link
                          href={item.url}
                          target={item.openNewWindow ? '_blank' : '_self'}
                          rel={item.openNewWindow ? 'noopenner noreferrer' : ''}
                          className="w-full px-5 py-3 font-source-sans text-[20px] font-bold leading-[1.5rem] tracking-[-0.3px] text-grey-1 no-underline"
                          onClick={resetView}
                        >
                          {item.title}
                          {item.subtitle && <div>{item.subtitle}</div>}
                        </Link>
                      </li>
                    )
                )}
              </ul>
            )}
          </li>
          <li className="group list-none hover:bg-black-standard/15">
            <div
              className="relative m-0 box-border cursor-pointer list-none px-4 py-[0.7rem] font-source-sans text-[1.25rem] font-normal tracking-[-0.3px] text-white no-underline transition-opacity duration-300 hover:bg-black-standard/15 group-hover:block"
              onClick={(e) => {
                e.preventDefault();
                setShowStandards(true);
              }}
              onMouseEnter={(e) => {
                e.preventDefault();
                setShowStandards(true);
              }}
            >
              <Link
                href={navData.ourStandards.slug}
                target="_self"
                className="relative block list-none px-0 py-3 font-source-sans text-[1.25rem] font-normal leading-[1.5rem] tracking-[-0.3px] text-white no-underline transition-opacity duration-300"
              >
                {navData.ourStandards.title}
              </Link>
            </div>
            {showStandards && (
              <ul className="absolute top-full z-[201] hidden border border-solid border-black-standard/10 bg-white shadow-component group-hover:block">
                {navData.ourStandards.items.map(
                  (item, index) =>
                    item.isHeader && (
                      <li
                        key={index}
                        className="p-3 hover:bg-black-standard/15"
                      >
                        <Link
                          href={item.url}
                          target={item.openNewWindow ? '_blank' : '_self'}
                          rel={item.openNewWindow ? 'noopenner noreferrer' : ''}
                          className="w-full px-5 py-3 font-source-sans text-[20px] font-bold leading-[1.5rem] tracking-[-0.3px] text-grey-1 no-underline"
                          onClick={resetView}
                        >
                          {item.title}
                          {item.subtitle && <div>{item.subtitle}</div>}
                        </Link>
                      </li>
                    )
                )}
              </ul>
            )}
          </li>
          <li className="group list-none hover:bg-black-standard/15">
            <div
              className="relative m-0 box-border cursor-pointer list-none px-4 py-[0.7rem] font-source-sans text-[1.25rem] font-normal tracking-[-0.3px] text-white no-underline transition-opacity duration-300 hover:bg-black-standard/15 group-hover:block"
              onClick={(e) => {
                e.preventDefault();
                setShowHomes(true);
              }}
              onMouseEnter={(e) => {
                e.preventDefault();
                setShowHomes(true);
              }}
            >
              <Link
                href={navData.ourHomes.slug}
                target="_self"
                className="relative block list-none px-0 py-3 font-source-sans text-[1.25rem] font-normal leading-[1.5rem] tracking-[-0.3px] text-white no-underline transition-opacity duration-300"
              >
                {navData.ourHomes.title}
              </Link>
            </div>
            {showHomes && (
              <ul className="absolute top-full z-[201] hidden border border-solid border-black-standard/10 bg-white shadow-component group-hover:block">
                {navData.ourHomes.items.map(
                  (item, index) =>
                    item.isHeader && (
                      <li
                        key={index}
                        className="p-3 hover:bg-black-standard/15"
                      >
                        <Link
                          href={item.url}
                          target={item.openNewWindow ? '_blank' : '_self'}
                          rel={item.openNewWindow ? 'noopenner noreferrer' : ''}
                          className="w-full px-5 py-3 font-source-sans text-[20px] font-bold leading-[1.5rem] tracking-[-0.3px] text-grey-1 no-underline"
                          onClick={resetView}
                        >
                          {item.title}
                          {item.subtitle && <div>{item.subtitle}</div>}
                        </Link>
                      </li>
                    )
                )}
              </ul>
            )}
          </li>
          <li className="group list-none hover:bg-black-standard/15">
            <div
              className="relative m-0 box-border cursor-pointer list-none px-4 py-[0.7rem] font-source-sans text-[1.25rem] font-normal tracking-[-0.3px] text-white no-underline transition-opacity duration-300 hover:bg-black-standard/15 group-hover:block"
              onClick={(e) => {
                e.preventDefault();
                setShowPartners(true);
              }}
              onMouseEnter={(e) => {
                e.preventDefault();
                setShowPartners(true);
              }}
            >
              <Link
                href={navData.ourBrandPartners.slug}
                target="_self"
                className="relative block list-none px-0 py-3 font-source-sans text-[1.25rem] font-normal leading-[1.5rem] tracking-[-0.3px] text-white no-underline transition-opacity duration-300"
              >
                {navData.ourBrandPartners.title}
              </Link>
            </div>
            {showPartners && (
              <ul className="absolute top-full z-[201] hidden border border-solid border-black-standard/10 bg-white shadow-component group-hover:block">
                {navData.ourBrandPartners.items.map(
                  (item, index) =>
                    item.isHeader && (
                      <li
                        key={index}
                        className="p-3 hover:bg-black-standard/15"
                      >
                        <Link
                          href={item.url}
                          target={item.openNewWindow ? '_blank' : '_self'}
                          rel={item.openNewWindow ? 'noopenner noreferrer' : ''}
                          className="w-full px-5 py-3 font-source-sans text-[20px] font-bold leading-[1.5rem] tracking-[-0.3px] text-grey-1 no-underline"
                          onClick={resetView}
                        >
                          {item.title}
                          {item.subtitle && <div>{item.subtitle}</div>}
                        </Link>
                      </li>
                    )
                )}
              </ul>
            )}
          </li>
          <li className="group list-none hover:bg-black-standard/15">
            <div
              className="relative m-0 box-border cursor-pointer list-none px-4 py-[0.7rem] font-source-sans text-[1.25rem] font-normal tracking-[-0.3px] text-white no-underline transition-opacity duration-300 hover:bg-black-standard/15 group-hover:block"
              onClick={(e) => {
                e.preventDefault();
                setShowAboutUs(true);
              }}
              onMouseEnter={(e) => {
                e.preventDefault();
                setShowAboutUs(true);
              }}
            >
              <Link
                href={navData.about.slug}
                target="_self"
                className="relative block list-none px-0 py-3 font-source-sans text-[1.25rem] font-normal leading-[1.5rem] tracking-[-0.3px] text-white no-underline transition-opacity duration-300"
              >
                {navData.about.title}
              </Link>
            </div>
            {showAboutUs && (
              <ul className="absolute top-full z-[201] ml-[-150px] hidden border border-solid border-black-standard/10 bg-white shadow-component group-hover:block">
                {navData.about.items.map(
                  (item, index) =>
                    item.isHeader && (
                      <li
                        key={index}
                        className="px-5 py-3 hover:bg-black-standard/15"
                      >
                        <Link
                          href={item.url}
                          target={item.openNewWindow ? '_blank' : '_self'}
                          rel={item.openNewWindow ? 'noopenner noreferrer' : ''}
                          className="py-3 pr-5 font-source-sans text-[20px] font-bold leading-[1.5rem] tracking-[-0.3px] text-grey-1 no-underline"
                          onClick={resetView}
                        >
                          {item.title}
                          {item.subtitle && <div>{item.subtitle}</div>}
                        </Link>
                      </li>
                    )
                )}
              </ul>
            )}
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default DesktopHeader;
